import { combineReducers } from 'redux';
import bankDetailsReducer from './bankDetails/bank-details-slice';
import countriesReducer from './countries/countries-slice';
import fundsReducer from './funds/funds-slice';
import otpReducer from './otp/otp-slice';
import profileReducer from './profile/profile-slice';
import { rootApi } from './root-api';
import signalrReducer from './signalr/signalr-slice';
import languageReducer from './slices/language-slice';
import themeReducer from './slices/theme-slice';
import zendeskReducer from './slices/zendesk-slice';
import twoFactorReducer from './two-factor/two-factor-slice';

const combinedReducers = combineReducers({
  countries: countriesReducer,
  language: languageReducer,
  funds: fundsReducer,
  bankDetails: bankDetailsReducer,
  theme: themeReducer,
  profile: profileReducer,
  twoFactor: twoFactorReducer,
  otp: otpReducer,
  signalr: signalrReducer,
  zendesk: zendeskReducer,
  api: rootApi.reducer,
});

export type RootState = ReturnType<typeof combinedReducers>;

/**
 * This completely resets the redux store (typically used when logging out.)
 */

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET') {
    /**
     * Do not change theme on logout.  It must go through "setTheme" action.  (Otherwise body style and store do not match)
     */

    state = {
      theme: state.theme,
    };
  }
  return combinedReducers(state, action);
};

export default rootReducer;
